import { Alert, Button, Col, Form, Input, Modal, Row, Spin, Table, TimePicker, Tooltip, Upload } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError, modalSuccess } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';

function Shift() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'shift_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [isModalUpload, setIsModalUpload] = useState(false);

    const titlePage = 'Shift Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true,
        },
        {
            title: 'Clock In',
            dataIndex: 'time_in',
            key: "time_in",
            sorter: true,
        },
        {
            title: 'Clock Out',
            dataIndex: 'time_out',
            key: "time_out",
            sorter: true,
        },
        {
            title: 'Created Date',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => record.created_at !== "" ? (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Updated Date',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => record.updated_at !== "" ? (<p>{moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'shift_id';
        getApi("GET", `/shift?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'shift');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        apiCall({ method, url, data: { headers: { Authorization: 'Bearer ' + token } } })
            .then((res) => {
                if (res.status === "success") {
                    setData(res.data.data);
                    setPage(prev => ({ ...prev, pagination: { ...prev.pagination, total: res.data.total_data } }));
                }
                setLoading(false);
            }).catch((e) => {
                console.error(e.message);
                setLoading(false);
            });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        apiCall({ method, url, data: { data: values, headers: { Authorization: 'Bearer ' + token } } })
            .then((res) => {
                if (res.status === "success") {
                    setDataModal(null);
                    setIsAlert(true);
                    setTextAlert(res.message);
                    closeModal();
                } else {
                    modalError(res.message);
                }
                setLoading(false);
            }).catch((e) => {
                console.error(e.message);
                setLoading(false);
            });
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'Notice',
            content: 'Are you sure you want to delete this data?',
            onOk: () => postApi('DELETE', '/shift/' + v.shift_id, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit') {
            setDataModal(data);
            console.log(data)
            form.setFieldsValue({
                name: data.name,
                desc: data.desc,
                time_in: data.time_in ? moment(data.time_in, 'HH:mm:ss') : null,
                time_out: data.time_out ? moment(data.time_out, 'HH:mm:ss') : null,
            });
        }
        setIsModal(true);
    };

    const onFinish = (ev) => {
        ev.time_in = ev.time_in.format('HH:mm:ss');
        ev.time_out = ev.time_out.format('HH:mm:ss');
        if (dataModal != null) {
            postApi("PUT", '/shift/' + dataModal.shift_id, ev);
        } else {
            postApi("POST", '/shift', ev);
        }
    };

    const closeModal = () => {
        setDataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) setData([]);
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({ pagination: { current: 1, pageSize: 10 } });
    };

    const props = {
        onRemove: file => setFileList(prev => prev.filter(item => item.uid !== file.uid)),
        beforeUpload: file => { setFileList([file]); return false; },
        fileList,
    };

    const postUpload = (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        apiCall({ method, url, data: { data: values, headers: { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + token } } })
            .then((res) => {
                if (res.status === "success") {
                    setIsAlert(true);
                    setTextAlert(res.message);
                    modalSuccess('File uploaded successfully!');
                    setFileList([]);
                    closeModal();
                    setIsModalUpload(false);
                } else {
                    modalError(res.message);
                    setIsModalUpload(false);
                }
                setLoading(false);
            }).catch(() => {
                setIsModalUpload(false);
                setLoading(false);
            });
    };

    const handleUpload = () => {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', fileList[0]);
        postUpload('POST', '/upload/shifttime', formData);
    };

    return (
        <div>
            <Helmet><title>{titlePage}</title></Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Shift</h3>
            <Row>
                <Col span={12}>
                    <Row>
                        <Button type="primary" onClick={() => setIsModalUpload(true)}>
                            <PlusOutlined /><b style={{ marginLeft: 5 }}>Upload Excel</b>
                        </Button>
                        <Search
                            placeholder="Search"
                            allowClear
                            style={{ marginLeft: 10, width: '50%' }}
                            enterButton="Search"
                            size="middle"
                            onSearch={searchData}
                        />
                    </Row>
                </Col>
                <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined /><b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Upload File"
                open={isModalUpload}
                onOk={handleUpload}
                onCancel={() => setIsModalUpload(false)}
                okText={loading ? <Spin /> : 'Upload'}
                confirmLoading={loading}
                cancelText="Cancel"
            >
                <Upload {...props} maxCount={1} disabled={loading}>
                    <Button icon={<UploadOutlined />} disabled={loading || fileList.length > 0}>
                        {loading ? 'Uploading...' : 'Import Shift Data'}
                    </Button>
                </Upload>
            </Modal>

            <Modal title="Shift Data" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="name"
                        label="Shift Name"
                        rules={[{ required: true, message: 'Shift Name is required!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="time_in"
                        label="Clock In"
                        rules={[{ required: true, message: 'Clock In is required!' }]}
                    >
                        <TimePicker style={{ width: "100%" }} format="HH:mm:ss" />
                    </Form.Item>
                    <Form.Item
                        name="time_out"
                        label="Clock Out"
                        rules={[{ required: true, message: 'Clock Out is required!' }]}
                    >
                        <TimePicker style={{ width: "100%" }} format="HH:mm:ss" />
                    </Form.Item>
                    <Form.Item
                        name="desc"
                        label="Description"
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default Shift;
